export default {
  API_URL: "https://api.mo2.masorden.com/",
  ADMIN_API_URL: "https://admin.mo2.masorden.com/",
  GA_MEASUREMENTID: 'UA-210000501-2',
  FILE_VALIDATOR_URL: "https://gti-filevalidator.api.tress.com.mx/",
}